module.exports = __webpack_public_path__ + "img/OverseaMember29.5f3927ab.jpg";